/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import * as XLSX from "xlsx";
import { ExcelFileDownload } from "../../utils/helpers/excelFileGenerator";

function CsvPreview({
  show,
  domainBrand,
  handleClose,
  dto = { keys: [], dto: [] },
  mode = "",
  fileName,
}) {
  const ExcelFile = new ExcelFileDownload();
  const dictionary = domainBrand.domainBrand["languageDictionary"];

  const handleDefaultDownload = (dto, fileName) => {
    ExcelFile.generateDefaultCsv(dto, fileName);
    handleClose();
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      size={"xl"}
      scrollable
    >
      <Modal.Header closeButton={false}>
        <Modal.Title className="text-inherit csv">
          {dictionary
            ? dictionary["FILE_WITH_DATA_YOU_W_1317679651"]
            : `File with data you wish to upload has to be in ".csv" format and the columns inside need to follow this order:`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table striped responsive>
          <thead>
            <tr>
              {dto?.keys?.length > 0 && (
                <React.Fragment>
                  {dto?.keys?.map((i, index) => {
                    return (
                      <React.Fragment>
                        <th key={index}>{i}</th>
                      </React.Fragment>
                    );
                  })}
                </React.Fragment>
              )}
            </tr>
          </thead>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        &nbsp; &nbsp;
        <Button
          variant="primary"
          onClick={() => handleDefaultDownload(dto, fileName)}
          disabled={mode === "" ? true : false}
        >
          {dictionary
            ? dictionary["DOWNLOAD_CSV_SAMPL_-235068646"]
            : "Download CSV Sample"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CsvPreview;

CsvPreview.defaultProps = {
  handleClose: () => {},
};

CsvPreview.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
